module.exports = __webpack_public_path__ + "static/media/arrow_back.dd55cdeb.svg";